import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgSendIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
    >
      <path d="M56.5 7.5 29.333 34.667M56.706 6.02a1 1 0 0 1 1.274 1.274L40.833 56.286c-.3.855-1.49.903-1.858.076l-9.642-21.695-21.695-9.643c-.828-.367-.78-1.558.076-1.857z" />
    </g>
  </svg>
)
export default SvgSendIcon
